<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Reportes } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let egresos = $state(0);
  let defunciones = $state(0);
  let infecciones = $state(0);
  let indicadores = $state<Record<string, unknown> | null>(null);
  let error = $state<string | null>(null);

  function rangoMes() {
    const d = new Date();
    const desde = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
    const hasta = d.toISOString().slice(0, 10);
    return { desde, hasta };
  }

  async function cargar() {
    error = null;
    const { desde, hasta } = rangoMes();
    try {
      const [eg, def, inf, ind] = await Promise.all([
        Reportes.egresos().catch(() => []),
        Reportes.defunciones().catch(() => []),
        Reportes.infecciones().catch(() => []),
        Reportes.indicadores(desde, hasta).catch(() => null),
      ]);
      egresos = eg.length;
      defunciones = def.length;
      infecciones = inf.length;
      indicadores = ind;
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  const actions = [
    { id: 'reportes', label: 'Reportes MSPAS', icon: '📈' },
    { id: 'ingresos', label: 'Ingresos', icon: '📥' },
    { id: 'altas', label: 'Altas', icon: '🚪' },
  ];

  function num(k: string): string {
    const v = indicadores?.[k];
    if (v == null) return '—';
    return String(v);
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 120000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Indicadores MSPAS" subtitle="Reportes regulatorios del hospital" variant="mspas">
  <DashHero emoji="🏛️" title="Indicadores MSPAS" subtitle="Egresos, defunciones, infecciones e indicadores del periodo" variant="mspas" />
  <QuickActions {actions} onAction={onNavigate} />

  {#if error}<p class="err">{error}</p>{/if}

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Egresos registrados</div><div class="dash-kpi-value">{egresos}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Defunciones</div><div class="dash-kpi-value">{defunciones}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Infecciones</div><div class="dash-kpi-value">{infecciones}</div></div>
    <div class="dash-kpi"><div class="dash-kpi-label">Periodo</div><div class="dash-kpi-value">{new Date().toLocaleDateString('es-GT', { month: 'short', year: 'numeric' })}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12 panel">
      <header><h3>Indicadores del mes</h3></header>
      <div class="ind-grid">
        <div><span class="k">Camas operativas</span><strong>{num('camasOperativas')}</strong></div>
        <div><span class="k">Días cama disponibles</span><strong>{num('diasCamaDisponibles')}</strong></div>
        <div><span class="k">Días cama ocupados</span><strong>{num('diasCamaOcupados')}</strong></div>
        <div><span class="k">Tasa ocupación</span><strong>{num('tasaOcupacion')}</strong></div>
        <div><span class="k">Consultas externas</span><strong>{num('consultasExternas')}</strong></div>
        <div><span class="k">Emergencias</span><strong>{num('emergencias')}</strong></div>
      </div>
      {#if !indicadores && !error}
        <p class="empty">Sin datos de indicadores — use el módulo Reportes para capturar.</p>
      {/if}
    </div>
  </div>
</DashboardLayout>

<style>
  .err { color: var(--danger); font-size: 0.88rem; }
  .panel { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-elevated); overflow: hidden; }
  header { padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); background: var(--brand-soft); }
  h3 { margin: 0; font-size: 0.9rem; color: var(--brand-deep); }
  .ind-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr)); gap: 0.75rem; padding: 1rem; }
  .k { display: block; font-size: 0.72rem; color: var(--text-secondary); margin-bottom: 0.2rem; }
  strong { font-size: 1.1rem; color: var(--text-primary); }
  .empty { padding: 1rem; margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
</style>
